require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-1-ka-52-b.json") })
        }
      }, "path---photos-professional-1-ka-52-b");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-1-ka-52-b!./.cache/json/photos-professional-1-ka-52-b.json
// module id = 564
// module chunks = 231608221292675